export const MEMBER_TYPES = {
  EARNED: 0,
  USED: 1,
};

export const SOURCE_TYPES = {
  UNKNOWN: 0, // 未知
  ORDER: 1, // 订单
  REFUND: 2, // 退款
  REDEEM_GIFT_CARD: 3, // 兑换礼品卡
  SYSTEM_TOP_UP: 4, // 系统充值
  EXPIRED: 5, // 过期
  REDEEM_DISCOUNT_CODE: 6, // 已兑换
  FIRST_REGISTER: 7, // 首次注册
  BIRTHDAY_FILL_IN: 8, // 生日填写
  BIRTHDAY_GIFT: 9, // 生日礼品
  RECALL_DISCOUNT_CODE: 10, // 召回折扣券
};

export const DISCOUNT_CODE_TYPES = {
  BASIC: 1, // 基础折扣
  FREE_SHIPPING: 2, // 免运费折扣
};

export const PRIZE_COUPON_TYPES = {
  FREE_SHIPPING: 4,
  LOTTERY_AMOUNT_OFF: 5,
  LOTTERY_BUY_GET: 6,
} as const;

export const FREE_SHIPPING_MONTHS = {
  1: 10,
  2: 11,
  3: 12,
} as const;

// export const USERS = {
//   MY_ID: 8159852724470,
//   ID1: 8174833860854,
//   ID2: 8003419275510,
// };

export const GIFT_CARD_STATUS = {
  AVAILABLE: 1,
  UNAVAILABLE: 2,
};

export const DISCOUNT_STATUS = {
  AVAILABLE: 1,
  UNAVAILABLE: 2,
};

export const COUPON_STATUS = {
  AVAILABLE: 1,
  UNAVAILABLE: 2,
};

export interface AvailableGiftCardItem {
  id: number;
  type: number;
  value: number;
  amount: string;
  points: number;
  amountText: string;
}

// 可用的礼品卡
export const availableGiftCards: AvailableGiftCardItem[] = [
  {
    id: 1,
    type: 1,
    value: 5,
    amount: "$5.00",
    amountText: "US $5.00",
    points: 100,
  },
  {
    id: 2,
    type: 2,
    value: 15,
    amount: "$15.00",
    amountText: "US $15.00",
    points: 300,
  },
  {
    id: 3,
    type: 3,
    value: 25,
    amount: "$25.00",
    amountText: "US $25.00",
    points: 500,
  },
];
// 可用的折扣券
export const availableDiscountCards: AvailableGiftCardItem[] = [
  {
    id: 1,
    type: 1,
    value: 5,
    amount: "$5.00",
    amountText: "US $5.00",
    points: 100,
  },
  {
    id: 2,
    type: 2,
    value: 10,
    amount: "$10.00",
    amountText: "US $10.00",
    points: 200,
  },
  {
    id: 3,
    type: 3,
    value: 15,
    amount: "$15.00",
    amountText: "US $15.00",
    points: 300,
  },
  {
    id: 4,
    type: 4,
    value: 20,
    amount: "$20.00",
    amountText: "US $20.00",
    points: 400,
  },
  {
    id: 5,
    type: 5,
    value: 25,
    amount: "$25.00",
    amountText: "US $25.00",
    points: 500,
  },
  {
    id: 6,
    type: 6,
    value: 50,
    amount: "$50.00",
    amountText: "US $50.00",
    points: 1000,
  },
];
